import { SurveySite, SurveySiteUpdate } from "@fieldbook/common/types/surveySites"
import { useMutation } from "@tanstack/react-query"
import { psUpdate } from "@/lib/powersync/crud"

export type UpdateSurveySitePayload = SurveySiteUpdate & {
  id: string
  project_id: string
}

export const UPDATE_SURVEY_SITE_MUTATION_KEY = ["surveySites", "update"]

/**
 * Update a survey site by writing to PowerSync local SQLite.
 * PowerSync's uploadData syncs the change to Supabase.
 */
export async function updateSurveySiteFn(
  payload: UpdateSurveySitePayload,
): Promise<SurveySite> {
  const { id, project_id: _project_id, ...updateData } = payload

  const updateWithTimestamp = {
    ...updateData,
    updated_at: new Date().toISOString(),
  }

  await psUpdate("survey_sites", id, updateWithTimestamp)

  return { id, ...updateWithTimestamp } as unknown as SurveySite
}

export const useUpdateSurveySite = () => {
  return useMutation({
    mutationKey: UPDATE_SURVEY_SITE_MUTATION_KEY,
    mutationFn: updateSurveySiteFn,
    networkMode: "always",
    onSuccess: (_data, variables) => {
      import("@/lib/powersync/syncFailures").then(
        ({ dismissSyncFailuresForEntity }) =>
          dismissSyncFailuresForEntity(variables.id),
      )
    },
  })
}
